import { useDebugStore } from '@/store/debugStore.js';
import { useUserStore } from '@/store/userStore.js';
import { useLanguageStore } from '@/store/languageStore.js';

async function FetchData(config, route, method = 'GET', query = false, hasFiles = false) {
  let user = useUserStore();
  user = user?.user || null; // Use optional chaining to avoid errors

  const token = user?.token || ''; // Use optional chaining to avoid errors
  const debugStore = useDebugStore();
  let now = new Date();
  debugStore.lastRequest = now.toLocaleTimeString();
  const languageStore = useLanguageStore();
  let language = languageStore.selectedLanguage?.code || "en";
  
  const params = new URLSearchParams();
  if (config != null && method === 'GET') {
    const { select, where, orderby, take, skip } = config;
    if (select) params.append('select', select);
    if (where) params.append('where', where);
    if (orderby) params.append('orderby', orderby);
    if (take) params.append('take', take);
    if (skip) params.append('skip', skip);
  } else if (config != null && method !== 'GET') {
    Object.keys(config).forEach((key) => {
      params.append(key, config[key]);
    });
  }
  let url = process.env.VUE_APP_API_URL + "/" + route;
  // add header HTTP_LANG
  let options = {
    method: method,
    headers: {
      "accept-language": "$" + language + "$"
    },
  };
  if(!hasFiles){
    options.headers['Content-Type'] = 'application/json';
  }

  if (token) {
    options.headers['Authorization'] = `Bearer ${token}`;
  }

  if (query && method === 'POST') {
    url += '/query';
    options.body = JSON.stringify(config);
  } else if (method !== 'POST' && !query) {
    if (params.toString().length > 0 && method === 'GET') {
      url += '?' + params.toString();
    }else if(method == "PUT"){
      options.body = JSON.stringify(config);
    }
  } else if (method === 'POST' && !query) {
    options.body = JSON.stringify(config);
  }else if(method == "DELETE"){
    options.body = JSON.stringify(config);
  } else {
    console.error('Invalid configuration', config, method, query);
  }
  if(hasFiles) {
    options.body = config;
  }

  try {
    const response = await fetch(url, options);

    // Only parse as JSON if response is ok
    return await response.json();
  } catch (error) {
    console.error("FetchData: Network or parsing error", error);
    return null;
  }
}

export default FetchData;